export class ParameterType {
  public static free: string = 'free';
  public static categorial: string = 'categorial';
  public static numeric: string = 'numeric';
}
